// Utility for converting abbreviated room names to full names for estate floorplans

export const ROOM_NAME_MAPPINGS: Record<string, string> = {
  // Bedrooms
  'BR': 'Bedroom',
  'BR1': 'Bedroom 1',
  'BR2': 'Bedroom 2',
  'BR3': 'Bedroom 3',
  'BR4': 'Bedroom 4',
  'BR5': 'Bedroom 5',
  
  // Living spaces
  'LR': 'Living Room',
  'LR1': 'Living Room 1',
  'LR2': 'Living Room 2',
  
  // Kitchen
  'K': 'Kitchen',
  'K/D': 'Kitchen/Diner',
  
  // Bathroom/WC
  'BTH': 'Bathroom',
  'BTH1': 'Bathroom 1',
  'BTH2': 'Bathroom 2',
  'W/C': 'Water Closet',
  'WC': 'Water Closet',
  
  // Hallways and landings
  'H': 'Hallway',
  'H1': 'Hallway 1',
  'H2': 'Hallway 2',
  'L': 'Landing',
  'L1': 'Landing 1',
  'L2': 'Landing 2',
  
  // Storage
  'CPD': 'Cupboard',
  'ST': 'Storage',
  
  // Utility
  'UTL': 'Utility',
  'UT': 'Utility',
  
  // Dining
  'DR': 'Dining Room',
  'D': 'Dining',
  
  // Study/Office
  'STY': 'Study',
  'OFF': 'Office',
  
  // Conservatory
  'CON': 'Conservatory',
  
  // Garage
  'GAR': 'Garage',
  'G': 'Garage',
  
  // Porch
  'POR': 'Porch',
  
  // Ensuite
  'ENS': 'Ensuite',
};

/**
 * Converts abbreviated room name to full name for estate floorplans
 * @param abbreviatedName - The abbreviated room name (e.g., "BR1", "LR")
 * @returns Full room name (e.g., "Bedroom 1", "Living Room")
 */
export function expandRoomName(abbreviatedName: string): string {
  if (!abbreviatedName) return abbreviatedName;
  
  // Check direct mapping first
  if (ROOM_NAME_MAPPINGS[abbreviatedName]) {
    return ROOM_NAME_MAPPINGS[abbreviatedName];
  }
  
  // Try to extract prefix and number for dynamic expansion
  const match = abbreviatedName.match(/^([A-Z]+)(\d+)$/);
  if (match) {
    const [, prefix, number] = match;
    const baseMapping = ROOM_NAME_MAPPINGS[prefix];
    if (baseMapping) {
      return `${baseMapping} ${number}`;
    }
  }
  
  // Return original if no mapping found
  return abbreviatedName;
}

/**
 * Gets full room name if in estate mode, otherwise returns abbreviated name
 * @param abbreviatedName - The abbreviated room name
 * @param isEstate - Whether this is estate mode
 * @returns Full name if estate mode, abbreviated name otherwise
 */
export function getRoomDisplayName(abbreviatedName: string, isEstate: boolean = false): string {
  if (!isEstate) return abbreviatedName;
  return expandRoomName(abbreviatedName);
}
